import { h } from "preact";

import IconProps from "./IconProps";

function IconAndroidStudio({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? "var(--icon-color, #4285f4)";
    const secondaryFill = color ?? "var(--icon-color, #3DDC84)";
    const tertiaryFill = color ?? "var(--icon-color, #073042)";

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={secondaryFill} d="M11.444 7.878a.303.303 0 1 1 .544-.266.303.303 0 0 1-.544.266zm1.465 3.012a.303.303 0 1 1 .544-.265.303.303 0 0 1-.544.265zm.128-3.908a3.575 3.575 0 0 0-3.386-.416l3.183 6.544a3.578 3.578 0 0 0 1.762-2.92l1.207.085c.07.005.13-.046.134-.117a.125.125 0 0 0-.117-.134l-1.223-.087a3.735 3.735 0 0 0-.38-1.547 3.74 3.74 0 0 0-.981-1.255l.686-1.016a.126.126 0 0 0-.207-.142l-.678 1.003"/>
            <path fill={fill} d="M10.103 9.446a6.54 6.54 0 0 1-2.87.653 6.601 6.601 0 0 1-5.525-2.982.301.301 0 0 0-.43-.077l-1.156.851a.304.304 0 0 0-.069.416 8.637 8.637 0 0 0 7.18 3.828 8.569 8.569 0 0 0 3.755-.855l-.885-1.834zM7.224 2.206h.625V.825a.625.625 0 0 0-1.25 0v1.381h.625z"/>
            <path fill={fill} d="M5.597 4.902 1.3 13.745c-.093.192-.143.4-.147.612l-.026 1.158a.35.35 0 0 0 .572.278l.895-.734a1.47 1.47 0 0 0 .39-.494l4.235-8.719-1.62-.943-.002-.001zM13.295 14.355a1.487 1.487 0 0 0-.147-.611L8.85 4.9l-1.62.946 4.234 8.716c.094.19.226.358.39.494l.895.735a.35.35 0 0 0 .572-.28l-.025-1.157-.002.001z"/>
            <path fill={tertiaryFill} d="M7.224 2.096a1.877 1.877 0 0 0-1.875 1.875c0 1.033.841 1.875 1.875 1.875a1.878 1.878 0 0 0 1.875-1.875 1.878 1.878 0 0 0-1.875-1.875zm0 2.907a1.032 1.032 0 1 1 .001-2.062 1.032 1.032 0 0 1-.001 2.062z"/>
        </svg>
    );
}

export default IconAndroidStudio;
